import { useMutation } from "@tanstack/react-query"
import {
  postNewsletterConfirm,
  postNewsletterConfirmParameters,
  postNewsletterSubscription,
  postNewsletterSubscriptionParameters,
} from "../api/newsletter-api"
import { toast } from "react-toastify"
import axios from "axios"

export const useMutateSubscribe = () => {
  return useMutation({
    mutationFn: (variables: postNewsletterSubscriptionParameters) =>
      toast.promise(postNewsletterSubscription(variables), {
        success: "Erfolgreich übermittelt!",
        pending: "Wird gesendet...",
      }),
    onError: (error) => {
      console.log(error)
      if (axios.isAxiosError(error)) {
        toast.dismiss()
        switch (error.code) {
          case "ERR_BAD_REQUEST":
            toast.error("Diese Mail ist bereits registriert!")
            break
          case "ERR_NETWORK":
          default:
            toast.error("Ein Problem ist aufgetreten, versuchen Sie es später noch einmal")
        }
      }
      console.log(error)
    },
  })
}
export const useMutateConfirm = () => {
  return useMutation({
    mutationFn: (variables: postNewsletterConfirmParameters) =>
      toast.promise(postNewsletterConfirm(variables), {
        error: "Server konnte nicht erreicht werden",
        success: "Erfolgreich übermittelt!",
        pending: "Wird gesendet...",
      }),
  })
}
